import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { conversationendpoints } from "../apis";

// Destructure endpoints
const {
  CREATE_CONVERSATION_API,
  GET_USER_CONVERSATIONS_API,
  GET_CONVERSATION_BY_ID_API,
  DELETE_CONVERSATION_API,
  EDIT_CONVERSATION_TITLE_API
} = conversationendpoints;

// Update Conversation Title
export function updateConversationTitle(conversationId, newTitle) {
  return async () => {
    const toastId = toast.loading("Updating title...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "PUT",
        `${EDIT_CONVERSATION_TITLE_API}/${conversationId}`,
        { title: newTitle },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data) throw new Error("No response data");

      toast.success("Title updated");
      return response.data.conversation; 
    } catch (error) {
      console.error("UPDATE TITLE ERROR:", error);
      toast.error("Failed to update title");
      return null;
    } finally {
      toast.dismiss(toastId);
    }
  };
}

// Get All Conversations
export function getUserConversations() {
   // console.log("api",GET_USER_CONVERSATIONS_API)
  return async () => {
   // const toastId = toast.loading("Fetching conversations...");
    const token = JSON.parse(localStorage.getItem("token"));
   // console.log("token",token)

    try {
      const response = await apiConnector(
        "GET",
        GET_USER_CONVERSATIONS_API,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );
     // console.log("res",response)

     if (!response.data) throw new Error("No response data");

    //  toast.success("Conversations fetched");
      return response.data;
    } catch (error) {
      console.error("GET CONVERSATIONS ERROR:", error);
     // toast.error("Failed to fetch conversations");
      return [];
    } finally {
     // toast.dismiss(toastId);
    }
  };
}

// Get One Conversation by ID
export function getConversationById(conversationId) {
  return async () => {
   // const toastId = toast.loading("Fetching conversation...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "GET",
        `${GET_CONVERSATION_BY_ID_API}/${conversationId}`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data) throw new Error("No response data");

     // toast.success("Conversation loaded");
      return response.data;
    } catch (error) {
     // console.error("GET CONVERSATION BY ID ERROR:", error);
     // toast.error("Failed to load conversation");
      return null;
    } finally {
     // toast.dismiss(toastId);
    }
  };
}

// Create Conversation
export function createConversation(title, initialMessage = "") {
  return async (dispatch) => {
    const toastId = toast.loading("Creating conversation...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "POST",
        CREATE_CONVERSATION_API,
        {
          title,
          initialMessage,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data) throw new Error("No response data");

    //  toast.success("Conversation created");
      return response.data;
    } catch (error) {
      console.error("CREATE CONVERSATION ERROR:", error);
      toast.error("Failed to create conversation");
      return null;
    } finally {
      toast.dismiss(toastId);
    }
  };
}

// Delete Conversation
export function deleteConversation(conversationId) {
  return async () => {
    const toastId = toast.loading("Deleting conversation...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "DELETE",
        `${DELETE_CONVERSATION_API}/${conversationId}`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data) throw new Error("No response data");

      toast.success("Conversation deleted");
      return true;
    } catch (error) {
      console.error("DELETE CONVERSATION ERROR:", error);
      toast.error("Failed to delete conversation");
      return false;
    } finally {
      toast.dismiss(toastId);
    }
  };
}
